module.exports = __webpack_public_path__ + "img/profile-bg8.57e9db61.jpg";